import { Config } from "../config/Config";
import { firestore } from "../utilities/Firebase";

/**
 * キャンペーンサービス
 */
export const CampaignService = () => {
  /**
   * Firestore からキャンペーン情報を取得する
   * @param id キャンペーンID
   * @return キャンペーン情報
   */
  const getCampaign = async (id: string) => {
    const path = Config.appEnv!;
    const doc = await firestore.collection(path).doc(id).get();

    if (!doc.exists) {
      throw new Error(
        `Firestore campaign document is not found. path: ${path} id: ${id}`
      );
    }

    return doc.data();
  };

  /**
   * Firestore から達成者数情報を取得する
   * @param id キャンペーンID
   * @returns 達成者情報
   */
  const getAchievedParticipants = async (id: string) => {
    const path = `${Config.appEnv}/${id}/Transactional`;
    const doc = await firestore
      .collection(path)
      .doc("AchievedParticipants")
      .get();

    if (!doc.exists) {
      throw new Error(`Firestore AchievedParticipants is not found.`);
    }

    return doc.data();
  };

  return { getCampaign, getAchievedParticipants };
};
